import * as THREE from 'three'
import Sizes from './Utils/Sizes'
import Time from './Utils/Time'
import Camera from './Camera'
import Renderer from './Renderer'
import World from './World/World'
import StatsExperience from './Utils/Stats'
import Resources from './Utils/Resources'
import sources from './sources'
import Debug from './Utils/Debug'
import FetchWrapper from './Data/fetchwrapper'
import { gsap } from "gsap";
import { interactedObjects } from './World/sets'
import LineElement from './World/LineElement'
import Controls from './Utils/Controls'
import SceneUtils from './Utils/SceneUtils'
import UIHandlers from './Utils/UIHandlers'
import SceneOperations from './Utils/SceneOperations'
import DataFetcher from './Data/arenafetcher'
import ConnectionManager from './Utils/ConnectionManager'
import PathView from './Utils/PathView'
import ExportPath from './Data/ExportPath'
import LoadPaths from './Data/LoadPaths'
import ImportPath from './Data/ImportPath'
import CameraPathTracker from './World/CameraPathTracker'
import { debugLog } from './Utils/debugLog'
let instance: Experience | null = null

export default class Experience
{
    debug!: Debug
    API!: FetchWrapper
    canvas: HTMLCanvasElement | null = null
    sizes!: Sizes
    scene: THREE.Scene = new THREE.Scene()
    resources!: Resources
    camera!: Camera
    renderer!: Renderer
    stats!: StatsExperience
    time!: Time
    world!: World
    controls!: Controls
    sceneUtils!: SceneUtils
    uiHandlers!: UIHandlers
    connectionManager!: ConnectionManager
    sceneOperations!: SceneOperations
    dataFetcher!: DataFetcher
    pathview!: PathView
    startTimeout: ReturnType<typeof setTimeout> | null = null
    firstClickedChannel = true
    exportPath!: ExportPath
    loadPaths!: LoadPaths
    importPath!: ImportPath
    cameraPathTracker: CameraPathTracker | null = null
    showCamLines = true
    sceneDocId: string | null = null
    saveTimeout: ReturnType<typeof setTimeout> | null = null

    constructor(canvas: HTMLCanvasElement | null = null)
    {
        // Singleton
        if(instance)
            {
                return instance
            }
        instance = this

        // Global access
        const globalWindow = window as Window & { experience?: Experience };
        globalWindow.experience = this
        this.debug = new Debug()
        this.API = new FetchWrapper("https://api.are.na/v3")
        this.canvas = canvas
        this.sizes = new Sizes()
        this.scene = new THREE.Scene()
        this.resources = new Resources(sources)
        this.camera = new Camera(this)
        const cameraControls = this.camera.getCameraControls()
        this.renderer = new Renderer(this)
        this.stats = new StatsExperience()
        this.time = new Time(cameraControls, this.renderer, this.scene, this.camera.instance, this.stats)
        this.world = new World()
        this.controls = new Controls(this) // Instantiate the Controls class
        this.sceneUtils = new SceneUtils(this.scene) // Instantiate the SceneUtils class
        this.uiHandlers = new UIHandlers() // Instantiate the UIHandlers class
        this.connectionManager = new ConnectionManager(this.dataFetcher, this.camera);
        this.sceneOperations = new SceneOperations() // Instantiate the SceneOperations class
        this.dataFetcher = new DataFetcher(null);
        this.pathview = new PathView()
        this.startTimeout = null;
        this.firstClickedChannel = true;
        this.exportPath = new ExportPath()
        this.loadPaths = new LoadPaths()
        this.importPath = new ImportPath()
        this.cameraPathTracker = null
        this.showCamLines = true
        this.sceneDocId = null; // Store the document ID here
        this.saveTimeout = null;

        

        this.sizes.on('resize', () =>
            {
                this.resize()
            })
        // Time tick event
        this.time.on('tick', () =>
            {
                this.update()
            })
    }
    resetTimeout() {
        if (this.startTimeout) {
            clearTimeout(this.startTimeout);
        }
        this.startTimeout = setTimeout(() => {
            // Implement the timeout logic here
        }, 1000);
    }
    resize()
    {
        debugLog('resize');
        this.camera.resize()
        this.renderer.resize()
    }
    update()
    {
        this.camera.update()
        this.world.update()
    }
    destroy()
    {
        this.controls?.destroy?.()
        this.uiHandlers?.destroy?.()
        this.sizes?.destroy?.()
        this.sizes.off('resize')
        this.time.off('tick')
        // Traverse the whole scene
        this.scene.traverse((child: THREE.Object3D) =>
            {
                debugLog(child)
                // Test if it's a mesh
                if(child instanceof THREE.Mesh)
                    {
                        child.geometry.dispose()
                        // Loop through the material properties
                        for(const key in child.material)
                        {
                            const value = child.material[key]
                            // Test if there is a dispose function
                            if(value && typeof value.dispose === 'function')
                            {
                                value.dispose()
                            }
                        }
                    }
            })
            this.camera?.getCameraControls()?.dispose()
            this.renderer?.instance?.dispose()
            if(this.debug.active){this.debug.ui?.destroy()}
    }

}